import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

export const uploadsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        addNewUpload: builder.mutation({
            query:({folderId, file}) => ({
                url: `/api/uploads/${folderId}`,
                method: 'POST',
                body:file,
            }),
          
        }),
     
    }),
})

export const {
    useAddNewUploadMutation,
   
} = uploadsApiSlice

